<template>
  <div class="inspection">
    <div class="nav">
      <div class="nav-left">
        <div
          class="parallelogram-btn-left"
          style="margin-right: 0.5vw"
          @click="backPath"
        >
          <div>返回</div>
        </div>
      </div>
      <div class="nav-center">设备详情</div>
      <div class="nav-right">
        <!-- <div
          class="parallelogram-btn-right"
          style="margin-right: 0.5vw"
          @click="downloadDatarReport"
        >
          <div>导出设备数据</div>
        </div> -->
      </div>
    </div>
    <div class="task-content">
      <div class="detail">
        <div class="detail-box">
          <div class="loading-data" v-if="loading" style="margin-top: 15vh">
            <i class="el-icon-loading"></i>
            <div>加载中，请稍后···</div>
          </div>
          <div class="detail-nav">
            <!-- <div class="detail-item" style="width: 3%">
              <div
                class="select-icon"
                :class="{ 'select-icon-active': all }"
                @click="selectAll"
              ></div>
            </div> -->
            <div class="detail-item" style="width: 12.1%">序号</div>
            <div class="detail-item" style="width: 12.1%">设备ID</div>
            <!-- 氧气设备 -->
            <div
              class="detail-item"
              v-show="nodeType == '01'"
              v-if="!SelectConut"
              style="width: 12.1%"
            >
              氧气浓度
            </div>
            <div
              class="detail-item"
              v-show="nodeType == '01'"
              v-else
              style="width: 12.1%"
            >
              氧气平均浓度
            </div>
            <!-- 二氧化碳设备 -->
            <div
              class="detail-item"
              v-show="nodeType == '02'"
              v-if="!SelectConut"
              style="width: 12.1%"
            >
              二氧化碳浓度
            </div>
            <div
              class="detail-item"
              v-show="nodeType == '02'"
              v-else
              style="width: 12.1%"
            >
              二氧化碳平均浓度
            </div>
            <!-- 温湿度设备 -->
            <div
              class="detail-item"
              v-show="nodeType == '03'"
              v-if="!SelectConut"
              style="width: 12.1%"
            >
              温度
            </div>
            <div
              class="detail-item"
              v-show="nodeType == '03'"
              v-else
              style="width: 12.1%"
            >
              平均温度
            </div>
            <div
              class="detail-item"
              v-show="nodeType == '03'"
              v-if="!SelectConut"
              style="width: 12.1%"
            >
              湿度
            </div>
            <div
              class="detail-item"
              v-show="nodeType == '03'"
              v-else
              style="width: 12.1%"
            >
              平均湿度
            </div>
            <!-- 包芯温度设备 -->
            <div
              class="detail-item"
              v-show="nodeType == '04'"
              v-if="!SelectConut"
              style="width: 12.1%"
            >
              温度
            </div>
            <div
              class="detail-item"
              v-show="nodeType == '04'"
              v-else
              style="width: 12.1%"
            >
              平均温度
            </div>
            <!-- 水分设备 -->
            <div
              class="detail-item"
              v-show="nodeType == '05'"
              v-if="!SelectConut"
              style="width: 12.1%"
            >
              水分
            </div>
            <div
              class="detail-item"
              v-show="nodeType == '05'"
              v-else
              style="width: 12.1%"
            >
              平均水分
            </div>
            <div class="detail-item" style="width: 12.1%">垛位号</div>
            <div class="detail-item" style="width: 12.1%">烟叶代码</div>
            <div class="detail-item" style="width: 12.1%">时间</div>
            <div class="detail-item" style="width: 12.1%">封垛时间</div>
          </div>
          <div class="detail-content" v-if="!loading">
            <div
              class="detail-list-wrapper"
              style="justify-content: end"
              v-if="!loading && tableData.length > 0"
              v-for="(data, index) in tableData"
              :key="index"
            >
              <!-- <div class="detail-item" style="width: 3%">
                <div
                  class="select-icon"
                  :class="{ 'select-icon-active': data.sign === 1 }"
                  @click="selectSingle(data)"
                ></div>
              </div> -->
              <div class="detail-item" style="width: 12.1%">
                {{ index + 1 }}
              </div>
              <div class="detail-item" style="width: 12.1%">
                {{ data.nodeId || "--" }}
              </div>
              <div class="detail-item" style="width: 12.1%">
                {{ SelectConut != "" ? data.avgVal : data.val }}
              </div>
              <div
                v-show="nodeType == '03'"
                class="detail-item"
                style="width: 12.1%"
              >
                {{ SelectConut != "" ? data.avgVal2 : data.val2 }}
              </div>
              <!-- <div class="detail-item" style="width: 13.9%">
                <el-popover
                  placement="top"
                  title=""
                  trigger="hover"
                  :content="data.materialName"
                >
                  <div
                    class="popover"
                    style="width: 8vw; text-align: center"
                    slot="reference"
                  >
                    {{ data.materialName ? data.materialName : "--" }}
                  </div>
                </el-popover>
              </div> -->
              <div class="detail-item" style="width: 12.1%">
                {{ data.stack || "--" }}
              </div>
              <div class="detail-item" style="width: 12.1%">
                {{ data.materialCode || "--" }}
              </div>
              <div v-if="SelectConut" class="detail-item" style="width: 12.1%">
                <!-- {{  renderTime(data.closeStackTime) || "--" }} -->
                {{ data.time || "--" }}
              </div>
              <div v-else class="detail-item" style="width: 12.1%">
                {{ getTime(data.createdTime) || "--" }}
                <!-- {{ data.time || "--" }} -->
              </div>
              <div class="detail-item" style="width: 12.1%">
                <!-- {{  renderTime(data.closeStackTime) || "--" }} -->
                {{ getTime(data.closeStackTime) || "--" }}
              </div>
            </div>
            <div class="none-data" v-if="!loading && tableData.length < 1">
              暂无数据
            </div>
          </div>
          <div class="page-wrapper" v-if="!loading && total > 9">
            <div class="page-wrapper-left">
              <div>共{{ total }}条数据，当前第{{ page }}页</div>
              <div style="margin-left: 5px">
                <DropDown
                  :content="rowsShow"
                  :items="rowsData"
                  v-on:sendInfo="rowsInfo"
                  class="DropDown"
                ></DropDown>
              </div>
            </div>
            <div class="page-wrapper-right">
              <div class="page-btn" @click="firstPage">首页</div>
              <div class="page-btn" @click="previousPage">上一页</div>
              <div class="page-btn" @click="nextPage">下一页</div>
              <div class="page-btn" @click="lastPage">尾页</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import DropDown from "../../../components/DropDownSingle";
import { querySheBeiDetail } from "../../../api/maintain";
import { renderTime, getDate } from "../../../tools/methods";
export default {
  name: "SheBeiDetail",
  components: { DropDown },
  data() {
    return {
      // time: ''
      time: [getDate(false), getDate(true)],
      nodeType: "",
      nodeName: "无线氧气传感器",
      tableData: [],
      warehouse: [],
      building: [],
      floor: [],
      area: [],
      stack: [],
      warehouseTitle: "请选择仓库",
      buildingTitle: "请选择楼号",
      floorTitle: "请选择层号",
      areaTitle: "请选择区号",
      stackTitle: "请选择垛位",
      siteId: "",
      siteType: "",
      loading: false,
      all: false,
      page: "1",
      rows: "9",
      total: "",
      rowsShow: "9 条/页",
      rowsData: [
        { name: "9 条/页", value: 7 },
        { name: "20 条/页", value: 20 },
        { name: "100 条/页", value: 100 },
        { name: "200 条/页", value: 200 },
      ],
      idList: [],
      excelData: {},
      storehouseFlag: false,
      contrastList: [],
      contrast1: "请选择对比数据",
      contrast2: "请选择对比数据",
      contrastShowBox: 0,
      contrast1show: 0,
      contrast2show: 0,
      // 养护阶段数据
      maintainStageData: [
        { name: "全部", value: "" },
        { name: "自然醇化阶段", value: "01" },
        { name: "防霉杀虫阶段", value: "02" },
        { name: "气调醇化阶段", value: "03" },
        { name: "气调保质阶段", value: "04" },
      ],
      maintainStage: "",
      CountType: [
        { name: "全部", value: "" },
        { name: "按月", value: "2" },
        { name: "按周", value: "1" },
        { name: "按天", value: "0" },
      ],
      BaoKuoSelect: [
        { name: "不包括", value: "0" },
        { name: "包括", value: "1" },
      ],
      // 选择月/周/天
      SelectConut: "",
      // 选择包括还是不包括
      containVal: "0",
      // 起点
      startTimeData: "",
      // 终点
      endTimeData: "",
      // 氧气浓度上限
      upperVal: "",
      // 氧气浓度下限
      lowerVal: "",
       UpperHumVal: "",
      // 湿度下限
      lowerHumVal: "",
      // 数据对比时间点
      nodeId: "",
      // 预警值
      val: "",
      // 预警范围
      compare: "",
      // 预警值
      val2: "",
      // 预警范围
      compare2: "",
      body111: {},
    };
  },
  created() {
    // let body = this.$route.query.body;
    this.page = this.$route.query.page;
    this.rows = this.$route.query.rows;
    this.nodeType = this.$route.query.nodeType;
    if (this.nodeType === "01") {
      this.nodeName = "无线氧气传感器";
    } else if (this.nodeType === "02") {
      this.nodeName = "无线二氧化碳传感器";
    } else if (this.nodeType === "03") {
      this.nodeName = "无线温湿度传感器";
    } else if (this.nodeType === "04") {
      this.nodeName = "无线包芯温度传感器";
    } else if (this.nodeType === "05") {
      this.nodeName = "无线包芯水分传感器";
    }
    this.siteId = this.$route.query.siteId;
    this.siteType = this.$route.query.siteType;
    this.maintainStage = this.$route.query.maintainStage;
    // 选择月/周/天
    this.SelectConut = this.$route.query.dayWeekMonth;
    // 包不包括
    this.containVal = this.$route.query.containVal;
    // 起点
    this.startTimeData = this.$route.query.dayStartDate;
    // 终点
    this.endTimeData = this.$route.query.dayEndDate;
    this.time[0] = this.$route.query.startDate;
    this.time[1] = this.$route.query.endDate;
    this.storehouseFlag = this.$route.query.storehouseFlag;
    // 氧气浓度上限
    this.upperVal = this.$route.query.upperVal;
    this.UpperHumVal=this.$route.query.UpperHumVal
    this.lowerHumVal=this.$route.query.lowerHumVal
    // 氧气浓度下限
    this.lowerVal = this.$route.query.lowerVal;
    this.nodeId = this.$route.query.nodeId;
    this.val = this.$route.query.val;
    this.compare = this.$route.query.compare;
    this.val2 = this.$route.query.val2;
    this.compare2 = this.$route.query.compare2;
    this.body111 = {
      page: this.page,
      rows: this.rows,
      nodeType: this.nodeType,
      siteId: this.siteId,
      siteType: this.siteType,
      maintainStage: this.maintainStage,
      // 选择月/周/天
      dayWeekMonth: this.SelectConut,
      // 包不包括
      containVal: this.containVal,
      // 起点
      dayStartDate: this.startTimeData,
      // 终点
      dayEndDate: this.endTimeData,
      startDate: this.time ? this.time[0] : "",
      endDate: this.time ? this.time[1] : "",
      storehouseFlag: this.storehouseFlag,
      // 氧气浓度上限
      upperVal: this.upperVal,
      UpperHumVal:this.UpperHumVal,
      lowerHumVal:this.lowerHumVal,
      // 氧气浓度下限
      lowerVal: this.lowerVal,
      val: this.val,
      compare: this.compare,
      val2: this.val2,
      compare2: this.compare2,
      nodeId: this.nodeId,
    };
    if ((this.compare && this.upperVal) || this.lowerVal || this.containVal) {
      // 氧气浓度上限
      this.upperVal = "";
      // 氧气浓度下限
      this.lowerVal = "";
      this.containVal = "";
    }
    let _this = this;
    setInterval(function () {
      _this.hide = true;
    }, 100);
    // if (this.SelectConut === "") {
    //   _this.getSeiBeiDetailAVG();
    // } else {
    _this.getSeiBeiDetail();
    // }
  },
  computed: {
    maintainCountQu: function () {
      return Math.floor(this.statusValue.maintainCount / 4);
    },
  },
  methods: {
    // 格式化时间
    getTime: function (time) {
      return renderTime(time);
    },
    //   获取设备详情列表
    getSeiBeiDetail: function () {
      console.log(this.upperVal);
      this.loading = true;
      //   this.hide=false;
      this.tableData = [];
      this.all = false;
      this.idList = [];
      this.body111.page=this.page
      this.body111.rows=this.rows
      querySheBeiDetail(this.body111)
        .then((res) => {
          res.data.rows &&
            res.data.rows.map((item) => {
              item.sign = 0;
              item.grey = 0;
              if (this.contrastList.length === 2) {
                if (
                  this.contrastList[0].nodeId === item.nodeId ||
                  this.contrastList[1].nodeId === item.nodeId
                ) {
                  item.grey = 1;
                }
              } else if (this.contrastList.length === 1) {
                if (this.contrastList[0].nodeId === item.nodeId) {
                  item.grey = 1;
                }
              }
            });
          this.tableData = res.data.rows;
          this.total = res.data.total;
          console.log(this.tableData);
          this.loading = false;
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
        });
    },
    // getSeiBeiDetailAVG: function () {
    //   this.loading = true;
    //   //   this.hide=false;
    //   this.tableData = [];
    //   this.all = false;
    //   this.idList = [];
    //   let body = {
    //     page: this.page,
    //     rows: this.rows,
    //     nodeType: this.nodeType,
    //     siteId: this.siteId,
    //     siteType: this.siteType,
    //     maintainStage: this.maintainStage,
    //     // 选择月/周/天
    //     dayWeekMonth: this.SelectConut,
    //     // 包不包括
    //     containVal: this.containVal,
    //     // 起点
    //     dayStartDate: this.startTimeData,
    //     // 终点
    //     dayEndDate: this.endTimeData,
    //     startDate: this.time ? this.time[0] : "",
    //     endDate: this.time ? this.time[1] : "",
    //     storehouseFlag: this.storehouseFlag,
    //     // 氧气浓度上限
    //     upperVal: this.upperVal,
    //     // 氧气浓度下限
    //     lowerVal: this.lowerVal,
    //     nodeId: this.nodeId,
    //   };
    //   console.log(body);
    //   querySheBeiDetailAVG(body)
    //     .then((res) => {
    //       res.data.rows &&
    //         res.data.rows.map((item) => {
    //           item.sign = 0;
    //           item.grey = 0;
    //           if (this.contrastList.length === 2) {
    //             if (
    //               this.contrastList[0].nodeId === item.nodeId ||
    //               this.contrastList[1].nodeId === item.nodeId
    //             ) {
    //               item.grey = 1;
    //             }
    //           } else if (this.contrastList.length === 1) {
    //             if (this.contrastList[0].nodeId === item.nodeId) {
    //               item.grey = 1;
    //             }
    //           }
    //         });
    //       this.tableData = res.data.rows;
    //       this.total = res.data.total;
    //       console.log(this.tableData);
    //       this.loading = false;
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //       this.loading = false;
    //     });
    // },
    backPath: function () {
      this.$router.go(-1);
    },
    // 导出表格数据处理
    downloadDatarReport() {
      if (!this.idList[0]) {
        this.$message({
          message: "请选择要导出的数据",
          type: "warning",
        });
      } else {
        console.log(this.tableData);
        if (!this.SelectConut) {
          if (this.nodeType === "01") {
            var tHeader = ["设备ID", "氧气浓度", "垛位号", "烟叶代码", "时间"];
            var filterVal = [
              "nodeId",
              "val",
              "stack",
              "materialCode",
              "createdTime",
            ];
            var list = this.idList.map((item) => {
              return {
                nodeId: item.nodeId,
                val: item.val,
                stack: item.stack,
                materialCode: item.materialCode,
                createdTime: this.getTime(item.createdTime),
              };
            });
          } else if (this.nodeType === "02") {
            var tHeader = [
              "设备ID",
              "二氧化碳浓度",
              "垛位号",
              "烟叶代码",
              "时间",
            ];
            var filterVal = [
              "nodeId",
              "val",
              "stack",
              "materialCode",
              "createdTime",
            ];
            var list = this.idList.map((item) => {
              return {
                nodeId: item.nodeId,
                val: item.val,
                stack: item.stack,
                materialCode: item.materialCode,
                createdTime: this.getTime(item.createdTime),
              };
            });
          } else if (this.nodeType === "03") {
            var tHeader = [
              "设备ID",
              "温度",
              "湿度",
              "垛位号",
              "烟叶代码",
              "时间",
            ];
            var filterVal = [
              "nodeId",
              "val",
              "val2",
              "stack",
              "materialCode",
              "createdTime",
            ];
            var list = this.idList.map((item) => {
              return {
                nodeId: item.nodeId,
                val: item.val,
                val2: item.val2,
                stack: item.stack,
                materialCode: item.materialCode,
                createdTime: this.getTime(item.createdTime),
              };
            });
          } else if (this.nodeType === "04") {
            var tHeader = ["设备ID", "温度", "垛位号", "烟叶代码", "时间"];
            var filterVal = [
              "nodeId",
              "val",
              "stack",
              "materialCode",
              "createdTime",
            ];
            var list = this.idList.map((item) => {
              return {
                nodeId: item.nodeId,
                val: item.val,
                stack: item.stack,
                materialCode: item.materialCode,
                createdTime: this.getTime(item.createdTime),
              };
            });
          } else if (this.nodeType === "05") {
            var tHeader = ["设备ID", "水分", "垛位号", "烟叶代码", "时间"];
            var filterVal = [
              "nodeId",
              "val",
              "stack",
              "materialCode",
              "createdTime",
            ];
            var list = this.idList.map((item) => {
              return {
                nodeId: item.nodeId,
                val: item.val,
                stack: item.stack,
                materialCode: item.materialCode,
                createdTime: this.getTime(item.createdTime),
              };
            });
          }
        }
        // 按月周天导出
        else {
          if (this.nodeType === "01") {
            var tHeader = [
              "设备ID",
              "平均氧气浓度",
              "垛位号",
              "烟叶代码",
              "时间",
            ];
            var filterVal = [
              "nodeId",
              "avgVal",
              "stack",
              "materialCode",
              "createdTime",
            ];
            var list = this.idList.map((item) => {
              return {
                nodeId: item.nodeId,
                avgVal: item.avgVal,
                stack: item.stack,
                materialCode: item.materialCode,
                createdTime: this.getTime(item.createdTime),
              };
            });
          } else if (this.nodeType === "02") {
            var tHeader = [
              "设备ID",
              "平均二氧化碳浓度",
              "垛位号",
              "烟叶代码",
              "时间",
            ];
            var filterVal = [
              "nodeId",
              "avgVal",
              "stack",
              "materialCode",
              "createdTime",
            ];
            var list = this.idList.map((item) => {
              return {
                nodeId: item.nodeId,
                avgVal: item.avgVal,
                stack: item.stack,
                materialCode: item.materialCode,
                createdTime: this.getTime(item.createdTime),
              };
            });
          } else if (this.nodeType === "03") {
            var tHeader = [
              "设备ID",
              "平均温度",
              "平均湿度",
              "垛位号",
              "烟叶代码",
              "时间",
            ];
            var filterVal = [
              "nodeId",
              "avgVal",
              "avgVal2",
              "stack",
              "materialCode",
              "createdTime",
            ];
            var list = this.idList.map((item) => {
              return {
                nodeId: item.nodeId,
                avgVal: item.avgVal,
                avgVal2: item.avgVal2,
                stack: item.stack,
                materialCode: item.materialCode,
                createdTime: this.getTime(item.createdTime),
              };
            });
          } else if (this.nodeType === "04") {
            var tHeader = ["设备ID", "平均温度", "垛位号", "烟叶代码", "时间"];
            var filterVal = [
              "nodeId",
              "avgVal",
              "stack",
              "materialCode",
              "createdTime",
            ];
            var list = this.idList.map((item) => {
              return {
                nodeId: item.nodeId,
                avgVal: item.avgVal,
                stack: item.stack,
                materialCode: item.materialCode,
                createdTime: this.getTime(item.createdTime),
              };
            });
          } else if (this.nodeType === "05") {
            var tHeader = ["设备ID", "平均水分", "垛位号", "烟叶代码", "时间"];
            var filterVal = [
              "nodeId",
              "avgVal",
              "stack",
              "materialCode",
              "createdTime",
            ];
            var list = this.idList.map((item) => {
              return {
                nodeId: item.nodeId,
                avgVal: item.avgVal,
                stack: item.stack,
                materialCode: item.materialCode,
                createdTime: this.getTime(item.createdTime),
              };
            });
          }
        }

        this.excelData = {
          tHeader: tHeader,
          filterVal: filterVal,
          list: list,
          name: this.nodeName,
        };
        console.log(this.excelData);
        this.export2Excel(this.excelData);
      }
    },
    export2Excel: function (body) {
      require.ensure([], () => {
        const { exportJson } = require("../../../vendor/Export2Excel");
        const tHeader = body.tHeader;
        const filterVal = body.filterVal;
        const list = body.list;
        const data = this.formatJson(filterVal, list);
        exportJson(tHeader, data, body.name + "--数据报表");
      });
      this.$message({
        message: "导出数据成功",
        type: "success",
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) => filterVal.map((j) => v[j]));
    },
    selectAll: function () {
      this.all = !this.all;
      let idList = [];
      if (this.all) {
        this.tableData.map((data, index) => {
          data.sign = 1;
          idList.push(data);
        });
        this.idList = idList;
      } else {
        this.tableData.map((data, index) => {
          data.sign = 0;
          this.idList = [];
        });
      }
      console.log(this.idList);
    },
    selectSingle: function (body) {
      this.tableData.map((data, index) => {
        console.log(body === data);
        if (body === data) {
          data.sign = data.sign === 1 ? 0 : 1;
          console.log(data.sign);
          if (data.sign === 1) {
            this.idList.push(data);
          } else {
            let idList = [];
            this.idList.map((item, index) => {
              if (item !== body) {
                idList.push(item);
              }
            });
            this.idList = idList;
          }
          console.log(this.idList);
        }
      });
      this.all = this.idList.length === this.tableData.length;
      console.log(this.idList);
    },
    firstPage: function () {
      console.log("首页");
      if (this.page === 1) {
        this.$message({
          message: "当前为第一页",
          type: "warning",
          center: "true",
          duration: "1000",
        });
      } else {
        this.page = 1;
        this.getSeiBeiDetail();
      }
    },
    previousPage: function () {
      console.log("上一页");
      if (this.page < 2) {
        this.$message({
          message: "当前为第一页",
          type: "warning",
          center: "true",
          duration: "1000",
        });
      } else {
        this.page--;
        this.getSeiBeiDetail();
      }
    },
    nextPage: function () {
      console.log("下一页");
      if (parseInt(this.total / this.rows) + 1 > this.page) {
        this.page++;
        this.getSeiBeiDetail();
      } else {
        this.$message({
          message: "当前为最后一页",
          type: "warning",
          center: "true",
          duration: "1000",
        });
      }
    },
    lastPage: function () {
      console.log("尾页");
      if (this.page === parseInt(this.total / this.rows) + 1) {
        this.$message({
          message: "当前为最后一页",
          type: "warning",
          center: "true",
          duration: "1000",
        });
      } else {
        if (Math.round(this.total % this.rows) === 0) {
          this.page = parseInt(this.total / this.rows);
        } else {
          this.page = parseInt(this.total / this.rows) + 1;
        }
        this.getSeiBeiDetail();
      }
    },
    rowsInfo: function (data) {
      console.log(data);
      this.rows = data.value;
      this.rowsShow = data.name;
      this.page = 1;
      this.getSeiBeiDetail();
    },
  },
};
</script>

<style scoped>
@import "historyData.css";
</style>



// WEBPACK FOOTER //
// src/page/maintain/historyData/SheBeiDetail.vue